@for (error of form().errors(); track error.kind) {
  @if (error.kind === 'serverError') {
    <p class="text-danger">{{ error.message }}</p>
  }
}
